import { CartProductDto } from './cartProduct.dto';

export class TableGuestDto {
  public id: number;
  public saleUnitCartId: number;
  public cartId: number;
  public merchantId: number;
  public merchantSaleUnitId: number;
  public cartProducts?: CartProductDto[];

  constructor(
    id: number,
    saleUnitCartId: number,
    cartId: number,
    merchantId: number,
    merchantSaleUnitId: number,
    cartProducts: CartProductDto[] = [],
  ) {
    this.id = id;
    this.saleUnitCartId = saleUnitCartId;
    this.cartId = cartId;
    this.merchantId = merchantId;
    this.merchantSaleUnitId = merchantSaleUnitId;
    this.cartProducts = cartProducts;
  }
}
